(function() {
  var upsell = document.querySelector('[data-warranty-upsell]');
  if (!upsell) return;

  var cards = upsell.querySelectorAll('[data-warranty-card]');
  cards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      var input = card.querySelector('.warranty-card__input');
      var wasChecked = card.classList.contains('is-selected');

      cards.forEach(function(c) {
        c.classList.remove('is-selected');
        c.querySelector('.warranty-card__input').checked = false;
      });

      if (!wasChecked) {
        card.classList.add('is-selected');
        input.checked = true;
      }

      e.preventDefault();
    });
  });

  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    var selected = upsell.querySelector('.warranty-card__input:checked');
    if (!selected) return;

    e.preventDefault();

    var mainVariantId = form.querySelector('[name="id"]').value;
    var warrantyVariantId = selected.value;

    var items = [
      { id: parseInt(mainVariantId), quantity: 1 },
      { id: parseInt(warrantyVariantId), quantity: 1 }
    ];

    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) {
      items[0].quantity = parseInt(qtyInput.value) || 1;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('Warranty upsell error:', err);
      selected.checked = false;
      form.submit();
    });
  });
})();